import { request } from '../network_new';

const walletServices = {
  //
  isHasDkRecharge(data: any) {
    return request.post(`/v1`, data, {
      headers: {
        cmdId: 390012,
        headerType: 2,
        paramType: 0,
        apiName: 'isHasDkRecharge',
      },
    });
  },
  // 获取支付渠道列表
  getPayChannelList(data: any) {
    return request.post(`/v1`, data, {
      headers: {
        cmdId: 3101392,
        headerType: 2,
        paramType: 0,
        apiName: 'getPayChannelList',
      },
    });
  },
  // 获取绑定的钱包地址列表
  getBindWalletAddressList(data: number[]) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 310430,
        headerType: 2,
        paramType: 2,
        apiName: 'getBindWalletAddressList',
      },
    });
  },
  // 用户的默认银行卡信息
  reqDefaultBankCard2(data: number[]) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 310435,
        paramType: 2,
        apiName: 'reqDefaultBankCard2',
      },
    });
  },
  // 用户的默认银行卡信息-新
  reqDefaultBankCard(data: Record<string, any>) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 3104351,
        paramType: 0,
        apiName: 'reqDefaultBankCard',
      },
    });
  },
  // 转换所有余额
  reqTransitionAllYe(data: Record<string, any>) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 3911381,
        headerType: 2,
        paramType: 0,
        apiName: 'reqTransitionAllYe',
      },
    });
  },
  // 请求账户余额(汇总)
  reqBlanceCollect(data: number[], cmdId: number = 340234) {
    return request.post('/v1', data, {
      headers: {
        cmdId,
        headerType: 2,
        paramType: 2,
        apiName: 'reqBlanceCollect',
      },
    });
  },
  // 获取虚拟货币地区汇率
  getExchangeRateData(data: Record<string, any>) {
    return request.post(
      '/v1',
      {
        ...data,
        option_code: 'EXCHANGE_RATE_OF_WITHDRAWAL_VIRTUAL_CURRENCY',
      },
      {
        headers: {
          cmdId: 370730,
          apiName: 'getExchangeRateData',
        },
      }
    );
  },
  // 一些配置 线下充值银行卡配置
  reqOfflineConfig(data: Record<string, any>) {
    return request.post(
      '/v1',
      {
        ...data,
        option_code: 'OFFLINE_RECHARGE_LIMIT',
      },
      {
        headers: {
          cmdId: 370730,
          headerType: 2,
          paramType: 0,
          apiName: 'reqOfflineConfig',
        },
      }
    );
  },
  // 获取系统配置
  getSysConfig(data: Record<string, any>) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 370730,
        headerType: 2,
        paramType: 0,
        apiName: 'getSysConfig',
      },
    });
  },
  // 提现配置数据
  getWithdrawConfig(data: number[]) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 310140,
        headerType: 2,
        paramType: 2,
        apiName: 'getWithdrawConfig',
      },
    });
  },
  // 获取银行列表
  reqNewBankList(data: number[]) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 371234,
        paramType: 2,
        apiName: 'reqNewBankList',
      },
    });
  },
  // 设定默认银行卡
  reqReDefaultBankCard(data: number[]) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 310412,
        paramType: 2,
        apiName: 'reqReDefaultBankCard',
      },
    });
  },
  // 检查提现密码是否正确
  reqTestWithdrawPassword(data: Record<string, any>) {
    return request.post('/v1', data, {
      headers: {
        cmdId: 310136,
        headerType: 2,
        paramType: 0,
        apiName: 'reqTestWithdrawPassword',
      },
    });
  },
  // 检查提现密码是否正确
  reqAddWithdraw(data: Record<string, any>) {
    return request.post('/v2', data, {
      headers: {
        cmdId: 341200,
        paramType: 1,
        apiName: 'reqAddWithdraw',
      },
    });
  },
  // 查询绑定的三方数字钱包数据
  getBindThirdWalletData(data: Record<string, any>) {
    return request.post('/v2', data, {
      headers: {
        cmdId: 383030,
        paramType: 0,
        apiName: 'getBindThirdWalletData',
      },
    });
  },
  // 查询是否绑定的三方数字钱包
  reqBindThirdWallet(data: Record<string, any>) {
    return request.post('/v2', data, {
      headers: {
        cmdId: 383033,
        paramType: 0,
        apiName: 'reqBindThirdWallet',
      },
    });
  },
  // 查询三方数字钱包注册地址
  getThirdWalletRegisterLink(data: Record<string, any>) {
    return request.post('/v2', data, {
      headers: {
        cmdId: 383032,
        paramType: 0,
        apiName: 'getThirdWalletRegisterLink',
      },
    });
  },
  // 查询三方数字钱包充值地址
  getThirdWalletDepositLink(data: Record<string, any>) {
    return request.post('/v2', data, {
      headers: {
        cmdId: 383031,
        paramType: 0,
        apiName: 'getThirdWalletDepositLink',
      },
    });
  },
  // 请求三方发送手机验证码
  reqPhoneVerifyCode(data: Record<string, any>) {
    return request.post('/v2', data, {
      headers: {
        cmdId: 383034,
        paramType: 0,
        apiName: 'reqPhoneVerifyCode',
      },
    });
  },
  // 获取实时汇率
  getExchangeRate(data: Record<string, any>) {
    return request.post('/v2', data, {
      headers: {
        cmdId: 383035,
        paramType: 0,
        apiName: 'getExchangeRate',
      },
    });
  },
};

export default walletServices;
